import { createSelector } from 'reselect';

export const selectWristbandsSlice = state => state.wristbands;

export const selectWristbands = createSelector(
  selectWristbandsSlice,
  slice => slice.wristbands
);
export const wristbandsLoaded = createSelector(
  selectWristbandsSlice,
  slice => slice.wristbandsLoaded
);
export const selectActiveWristband = createSelector(
  selectWristbandsSlice,
  slice => slice.activeWristband
);

export const wristbandsMeta = createSelector(
  selectWristbandsSlice,
  slice => slice.meta
);
export const wristbandsFilters = createSelector(
  selectWristbandsSlice,
  slice => slice.filters
);

export const wristbandCreating = createSelector(
  selectWristbandsSlice,
  slice => slice.isCreating
);
export const wristbandUpdating = createSelector(
  selectWristbandsSlice,
  slice => slice.isUpdating
);
export const wristbandDeleting = createSelector(
  selectWristbandsSlice,
  slice => slice.isDeleting
);
export const wristbandsErrors = createSelector(
  selectWristbandsSlice,
  slice => slice.errors
);
